import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { onClickChangeUserStatus } from "../../modules/actions/index";
import {
  callApiUsersList,
  callApiUpdateUser,
  callApiFetchCompanyUserList,
  callApiGetBusinessIdUsingSubdomain,
} from "../../services";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { authUserData } from "../../helpers";
import Header from "../../components/Header";
import ChangeStatusConfirmationModal from "../../components/modals/ChangeStatusConfirmationModal";
import BusinessAdminHeader from "../../components/BusinessAdminHeader";

class CompanyUsers extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      currentUser: null,
      users: null,
      userId: null,
      userStatus: null,
      deletedId: null,
      showModal: false,
      businessId: null,
      subdomain: null,
      userData: null,
      isAdmin: false,
      currentPage: 1,
      itemsPerPage: 20,
    };
  }

  componentDidMount = async () => {
    const hostname = window.location.hostname;

    // Split by dots
    const parts = hostname.split(".");

    // Get the subdomain (first part)
    const subdomain = parts[0];

    // "subdomain", subdomain);

    const userData = authUserData();

    // Get businessId from query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const businessIdFromUrl = urlParams.get('businessId');

    // let currentBusinessId;

    // console.log("useData Dashboard", userData);

    if (userData) {
      this.setState({
        subdomain,
        userData,
      });
    }

    if (userData && userData.isAdmin && userData.isAdmin === true) {
      // If admin user and businessId is provided in URL, use it for filtering
      this.setState({
        isAdmin: true,
        businessId: businessIdFromUrl || null,
        currentUser: userData,
      }, () => {
        // Call renderCompanyUsersList after state is updated
        this.renderCompanyUsersList();
      });
    } else {
      callApiGetBusinessIdUsingSubdomain(subdomain)
        .then(async (res) => {
          // console.log("api res subdomain business ID", res);
          if (res.data && res.data.length > 0) {
            // console.log(990099);
            this.setState({
              businessId: res.data && res.data.length > 0 && res.data[0]._id,
              subdomain,
              currentUser: userData,
            }, () => {
              // Call renderCompanyUsersList after state is updated
              this.renderCompanyUsersList();
            });
          }
        })
        .catch((error) => {
          // console.log("Dashboard fetch saq data ... error", error);
        });
    }
  };

  renderCompanyUsersList = async () => {
    // console.log("renderCompanyUsersList", this.state.businessId);
    callApiFetchCompanyUserList({ businessId: this.state.businessId })
      .then((res) => {
        console.log("api res copany user list", res.data);
        if (res.success && res.data && res.data.length > 0) {
          this.setState({
            users: res.data,
          });
        }
      })
      .catch((error) => {
        // console.log("Dashboard fetch saq data ... error", error);
      });
  };

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  onCloseModal = () => {
    this.setState({ showModal: false });
  };

  onSelectAction = (userStatus, userId) => {
    this.setState({ showModal: true, userId: userId, userStatus: userStatus });
  };

  handleChangeStatus = () => {
    // console.log("01. handleChangeStatus");

    this.props.onClickChangeUserStatus({
      purpose: "UPDATE_USER",
      userId: this.state.userId,
      userStatus: this.state.userStatus,
    });
  };

  getUserType = (businessDetails) => {
    console.log("businessDetails", businessDetails[0].userType);

    return (
      businessDetails &&
      businessDetails.length === 1 &&
      businessDetails[0].userType &&
      businessDetails[0].userType.charAt(0).toUpperCase() +
        businessDetails[0].userType.slice(1)
    );
  };

  getUserBusiness = (businessDetails) => {
    console.log("businessDetails", businessDetails[0].userType);

    return (
      businessDetails &&
      businessDetails.length === 1 &&
      businessDetails[0].businessName &&
      businessDetails[0].businessName.charAt(0).toUpperCase() +
        businessDetails[0].businessName.slice(1)
    );
  };

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };

  getPaginatedUsers = () => {
    const { users, currentPage, itemsPerPage, currentUser } = this.state;
    if (!users || users.length === 0) return [];

    const filteredUsers = users
      .slice(0)
      .reverse()
      .filter(
        (v) => v._id !== currentUser?.userId && (v?.isAdmin === false || v)
      );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    return filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  };

  getTotalPages = () => {
    const { users, itemsPerPage, currentUser } = this.state;
    if (!users || users.length === 0) return 0;

    const filteredUsers = users.filter(
      (v) => v._id !== currentUser?.userId && (v?.isAdmin === false || v)
    );

    console.log("filteredUsers", filteredUsers);

    return Math.ceil(filteredUsers.length / itemsPerPage);
  };

  /* componentWillReceiveProps(newProps) {
    if (
      newProps.userData &&
      newProps.userData &&
      newProps.userData.success === true
    ) {
      this.renderUserList();
    }
  } */

  render() {
    const { history } = this.props;
    const { isAdmin, currentUser, users, deletedId, showModal, companyId } =
      this.state;

    return (
      <>
        <ToastContainer />
        <div className="cell small-12 medium-10" id="maincontent">
          {currentUser && !currentUser.isAdmin && <BusinessAdminHeader />}
          <div id="body-content">
            <div className="grid-x grid-margin-x grid-margin-y">
              <div className="cell small-12 medium-12" id="completedsaqs">
                <div className="module-header">
                  <h3>Company Users</h3>
                  {currentUser && !currentUser.isAdmin && (
                    <Link to={`/control-panel/users/create`}>
                      <button className="button nxt-btn">Create User</button>
                    </Link>
                  )}

                  {currentUser && currentUser.isAdmin && (
                    <Link to={`/control-panel/companies`}>
                      <button className="button nxt-btn">Back</button>
                    </Link>
                  )}
                </div>
                <div id="compltedsaqs-table">
                  <table>
                    <thead>
                      <tr>
                        <th width="250">Email</th>
                        {isAdmin === true && <th>Business</th>}
                        {isAdmin === true && <th>Type</th>}
                        <th>Status</th>
                        {/* <th width="200">SAQ's</th> */}
                        <th width="200">Created At</th>
                        <th width="150">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users && users.length > 0 ? (
                        this.getPaginatedUsers().map((v, i) => {
                          return (
                            <tr key={uuidv4()}>
                              <td>{v.email}</td>
                              {isAdmin === true && (
                                <td>
                                  {this.getUserBusiness(v.businessDetails)}
                                </td>
                              )}
                              {isAdmin === true && (
                                <td>{this.getUserType(v.businessDetails)}</td>
                              )}
                              <td>
                                {v.userStatus &&
                                  v.userStatus === "active" &&
                                  "Active"}
                                {v.userStatus &&
                                  v.userStatus === "inactive" &&
                                  "Inactive"}
                              </td>
                              {/* <td>
                                <button
                                  className="button"
                                  style={{
                                    background: "#ffffff",
                                    border: "2px solid #006400",
                                    borderRadius: "4px",
                                    color: "#000000",
                                  }}
                                >
                                  View SAQ's
                                </button>
                              </td> */}
                              <td>
                                {moment(v.createdAt).format("MMMM Do YYYY")}
                              </td>
                              <td>
                                <select
                                  onChange={(e) =>
                                    this.onSelectAction(e.target.value, v._id)
                                  }
                                >
                                  <option>Options</option>
                                  {v.userStatus &&
                                    v.userStatus === "active" && (
                                      <option value="inactive">Inactive</option>
                                    )}
                                  {v.userStatus &&
                                    v.userStatus === "inactive" && (
                                      <option value="active">Active</option>
                                    )}
                                </select>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="3">No records.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {users && users.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "20px",
                      gap: "10px",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ marginBottom: "10px" }}>
                      Showing {this.getPaginatedUsers().length} of{" "}
                      {
                        users.filter(
                          (v) =>
                            v._id !== currentUser?.userId &&
                            (v?.isAdmin === false || v)
                        ).length
                      }{" "}
                      users
                    </div>
                    {this.getTotalPages() > 1 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <button
                          className="button"
                          onClick={() =>
                            this.handlePageChange(this.state.currentPage - 1)
                          }
                          disabled={this.state.currentPage === 1}
                          style={{
                            padding: "8px 16px",
                            opacity: this.state.currentPage === 1 ? 0.5 : 1,
                            cursor:
                              this.state.currentPage === 1
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          Previous
                        </button>
                        <span style={{ margin: "0 10px" }}>
                          Page {this.state.currentPage} of{" "}
                          {this.getTotalPages()}
                        </span>
                        <button
                          className="button"
                          onClick={() =>
                            this.handlePageChange(this.state.currentPage + 1)
                          }
                          disabled={
                            this.state.currentPage === this.getTotalPages()
                          }
                          style={{
                            padding: "8px 16px",
                            opacity:
                              this.state.currentPage === this.getTotalPages()
                                ? 0.5
                                : 1,
                            cursor:
                              this.state.currentPage === this.getTotalPages()
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <ChangeStatusConfirmationModal
            history={this.props.history}
            handleChangeStatus={() => this.handleChangeStatus()}
            showModal={showModal}
            onCloseModal={() => this.onCloseModal()}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.userStore.user,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      onClickChangeUserStatus,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyUsers);
